module.exports = __webpack_public_path__ + "static/media/3-2.c48a3cb4.svg";